import React from 'react'
import * as SocialMedia from 'components/constant/SocialMedia';
import MediaBG from '@/images/social_media_bg.png'

interface IState {
    copyright: string,
    medias: string[]
}

class Copyright extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props)
        this.state = {
            copyright: "© 2020 Jr. All rights reserved. Designed by SmallCorridor.",
            medias: [
                SocialMedia.FACEBOOK,
                SocialMedia.LINKEDIN,
                SocialMedia.GITHUB,
                SocialMedia.STACKOVERFLOW
            ]
        }
    }

    render() {
        var mediaBG = {
            backgroundImage: `url(${MediaBG})`
        }
        return (
            <footer>
                <div className="container">
                    <div className="row justify-content-between align-items-center">
                        <div className="copyright col-md-6 col-lg-8">
                            {this.state.copyright}
                        </div>
                        <div className="social-medias col-md-6 col-lg-4">
                            {
                                this.state.medias.map(m => {
                                    const media = SocialMedia.Medias[m]
                                    return (
                                        <div className="social-media" key={m}>
                                            <div className={`${m} d-flex justify-content-center`} style={mediaBG}>
                                                <a href={media.getUrl()} className=" align-self-center" target="_blank">
                                                    <img src={media.getImage().getSource()} alt={media.getName()}/>
                                                </a>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Copyright